module.exports = __webpack_public_path__ + "img/5448.abcabc13.jpg";